import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { EventToolbox } from 'client/utils/event-toolbox';
import { TrackingConstant } from 'client/tracking/constant';
import { bindToPath, connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { LeaseDealsModel, LeaseDealsPaths } from 'client/data/models/lease-deals';
import { getQuery } from 'client/utils/location';

function TrackInvalidDealIdUI({ selectedDeal = undefined, location = undefined }) {
  const rawId = getQuery(location).id;
  const selectedId = Array.isArray(rawId) ? rawId[0] : rawId;

  useEffect(() => {
    if (selectedId && selectedDeal === null) {
      EventToolbox.fireTrackAction({
        event_type: TrackingConstant.EVENT_TYPE_ACTION_COMPLETED,
        event_data: {
          creative_id: 'edm-lease-deals-hidden-gems',
          action_category: TrackingConstant.SYSTEM_ACTION_CATEGORY,
          action_cause: TrackingConstant.PAGE_LOAD_CAUSE,
          action_name: TrackingConstant.ACTION_SHOW_CONTENT,
          subaction_name: 'invalid_deal',
          value: selectedId,
        },
      });
    }
  }, [selectedDeal, selectedId]);

  return null;
}

TrackInvalidDealIdUI.propTypes = {
  selectedDeal: PropTypes.shape({}),
  location: PropTypes.shape({
    query: PropTypes.object,
    search: PropTypes.string,
  }),
};

const stateToPropsConfig = {
  selectedDeal: bindToPath(
    props => {
      const rawId = getQuery(props.location).id;
      const id = Array.isArray(rawId) ? rawId[0] : rawId;

      return id ? LeaseDealsPaths.getSelectedDealPath(id) : undefined;
    },
    LeaseDealsModel,
    undefined,
    false
  ),
};

export const TrackInvalidDealId = withRouter(connectToModel(TrackInvalidDealIdUI, stateToPropsConfig));
